export default "__VITE_PUBLIC_ASSET__783de330__"